import React, { useEffect, useState } from "react";

// JS Files

// Others File

const Table = ({ dataList }) => {
  return (
    <>
      <div className="grid md:grid-cols-8 gap-4 bg-mygray-200 py-2 px-4 rounded-lg">
        <div className="col-span-1">
          <span className="text-mygray-700 text-xs md:text-base">ردیف</span>
        </div>
        <div className="col-span-3">
          <span className="text-mygray-700 text-xs md:text-base">نام مرکز</span>
        </div>
        <div className="col-span-1">
          <span className="text-mygray-700 text-xs md:text-base">تلفن</span>
        </div>
        <div className="col-span-3">
          <span className="text-mygray-700 text-xs md:text-base">آدرس</span>
        </div>
      </div>
      {dataList.map((item, index) => {
        return [
          <div
            className={
              index % 2 == 0
                ? "grid md:grid-cols-8 gap-4 py-2 px-4 rounded-lg my-4 items-center"
                : "bg-mygray-50 grid md:grid-cols-8 gap-4 py-2 px-4 rounded-lg my-4 items-center"
            }
          >
            <div className="col-span-1">
              <span className="text-mygray-600 text-xs md:text-sm">
                {index + 1}
              </span>
            </div>
            <div className="col-span-3">
              <span className="text-mygray-600 text-xs md:text-sm">
                {item.name}{" "}
              </span>
            </div>
            <div className="col-span-1">
              <span className="text-mygray-600 text-xs md:text-sm">
                {item.phone}{" "}
              </span>
            </div>
            <div className="col-span-3">
              <span className="text-mygray-600 text-xs md:text-sm">
                {item.address}
              </span>
            </div>
          </div>,
        ];
      })}
    </>
  );
};
export default Table;
